import React from 'react';
import { Hero } from '../components/Hero';
import { Experience } from '../components/Experience';
import { Gallery } from '../components/Gallery';
import { Music } from '../components/Music';
import { Privatize } from '../components/Privatize';
import { Footer } from '../components/Footer';
export function Home() {
  return <main className="bg-obsidian min-h-screen" data-id="element-233">
      <Hero data-id="element-234" />
      <Experience data-id="element-235" />
      <Music data-id="element-236" />
      <Gallery data-id="element-237" />
      <Privatize data-id="element-238" />
      <Footer data-id="element-239" />
    </main>;
}